// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"476":"a2dc3ab10c2acb38","496":"b9febfe26fc6b90d","973":"87c92ee428dc21e1"}[chunkId] + ".js";
};